import $ from 'jquery';
import Swiper from 'swiper';

/**
 * Initialize Image Gallery Swiper carousels
 */
export function initImageGallerySwiper() {
	$('.image-gallery').each(function () {
		const galleryElement = this;
		const galleryId = galleryElement.id;
		const slideCount = galleryElement.querySelectorAll('.swiper-slide').length;
		const fraction = galleryElement.querySelector('.swiper-fraction');

		if (galleryElement && typeof Swiper !== 'undefined') {
			new Swiper(`#${galleryId}`, {
				a11y: {
					enabled: true,
					slideRole: 'button',
				},
				navigation: {
					nextEl: `#${galleryId} .swiper-button-next`,
					prevEl: `#${galleryId} .swiper-button-prev`,
				},
				on: {
					init: function (swiperInstance) {
						swiperInstance.slideTo(0, 0);
						if (fraction) {
							fraction.textContent = `1 of ${slideCount}`;
						}
					},
					slideChange: function (swiperInstance) {
						if (fraction) {
							fraction.textContent = `${swiperInstance.realIndex + 1} of ${slideCount}`;
						}
					},
				},
				slidesPerView: 'auto',
				centeredSlides: true,
				initialSlide: 0,
				breakpoints: {
					320: {
						spaceBetween: 20,
					},
					840: {
						spaceBetween: 20,
					},
					1024: {
						spaceBetween: 30,
					},
				},
			});
		}
	});
}
